import styled, { CSSObject } from '@emotion/styled';

export const FieldGrid = styled.div(
  (): CSSObject => ({
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 0.9fr) minmax(0, 1.1fr)',
    gap: '1rem',
    '@media (max-width: 600px)': {
      gridTemplateColumns: '1fr',
    },
  }),
);

export const NameRow = styled.div(
  (): CSSObject => ({
    gridColumn: '1 / -1',
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 0.9fr) minmax(0, 1.1fr)',
    gap: '1rem',
    '@media (max-width: 600px)': {
      gridTemplateColumns: '1fr',
    },
  }),
);

export const PinRow = styled.div(
  (): CSSObject => ({
    gridColumn: '1 / -1',
  }),
);

export const LastNameLangCell = styled.div(
  (): CSSObject => ({
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr) 72px',
    gap: '0.5rem',
    '@media (max-width: 600px)': {
      gridTemplateColumns: '1fr',
      gap: '1rem',
    },
  }),
);
